import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { AlertService } from 'src/app/shared/services/alert.service';
import { SponsorService } from 'src/app/shared/services/sponsor.service';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { ISponsor } from 'src/app/core/models/i-sponsor';

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.scss'],
})
export class SponsorsComponent {
  constructor(
    public formBuilder: FormBuilder,
    private alertService: AlertService,
  ) {}

  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() selectedSponsor: FormControl;
  @Input() isSponsored: FormControl;
  @Input() searchedSponsor: FormControl;
  @Input() searchSponsorList: IAutoCompleteData[];
  @Input() sponsorList: ISponsor[];

  isSearchingSponsors = false;
  isSaving = false;
  editingSponsor = false;

  handleSponsorSelected($event) {
    let selectedSponsor = this.sponsorList.filter((x) => x.id === $event.id);
    this.onSponsorSelected(selectedSponsor[0]);
  }

  onSponsorSelected(sponsor: ISponsor): void {
    if (this.selectedSponsor.value?.id === sponsor.id) {
      this.alertService.warning(
        `You've already added the author ${sponsor.name}, see below.`,
      );
      this.resetSearchedSponsorState();
      return;
    }

    this.addSelectedSponsor(sponsor);

    this.selectedSponsor.markAsDirty();
    this.resetSearchedSponsorState();
  }

  public resetSearchedSponsorState(): void {
    this.searchSponsorList = [];
    this.searchedSponsor.setValue('');
    this.searchedSponsor.markAsPristine();
  }

  public addSelectedSponsor(sponsor: ISponsor): void {
    this.selectedSponsor.setValue(sponsor);
    this.updateEditingSponsors();
  }

  resetSelectedSponsorState(): void {
    this.selectedSponsor.setValue(null);
  }

  updateEditingSponsors(): void {
    if (!this.isSponsored.value) {
      this.resetSelectedSponsorState();
      this.editingSponsor = false;
    } else {
      this.editingSponsor = !this.editingSponsor;
    }
  }
}
